module.exports = global["$"] = require("-!/codebuild/output/src1241359791/src/assets/node_modules/expose-loader/index.js?jQuery!./jquery.js");